import { graphql } from '@/gql/graphql';

export const EventRsvpPickerFragment = graphql(
  /* GraphQL */ `
    fragment EventRsvpPicker on event {
      id
      rsvp(args: { person_id: $personId })
      managed_rsvps: rsvps(
        where: {
          person: { person_manager_people: { manager_id: { _eq: $personId } } }
        }
      ) {
        event_id
        person_id
        status
      }
    }
  `,
);
